import { find } from 'lodash';
import moment from 'moment';

export const AVAILABLE_TIMESPANS = {
  TODAY: {
    parameter: 'TODAY',
    name: 'Today',
  },
  '3DAY': {
    parameter: '3DAY',
    name: '3 Days',
  },
  WEEK: {
    parameter: 'WEEK',
    name: 'Week',
  },
  MONTH: {
    parameter: 'MONTH',
    name: 'Month',
  },
  ALL: {
    parameter: 'ALL',
    name: 'All Time',
  },
  EMPTY: {
    parameter: '',
    name: '',
  },
};

export const DEFAULT_TIMESPANS = {
  movers: AVAILABLE_TIMESPANS.TODAY,
  traded: AVAILABLE_TIMESPANS.ALL,
};

export const DEFAULT_TIMESPANS_MARKETS = {
  ...DEFAULT_TIMESPANS,
  traded: AVAILABLE_TIMESPANS.TODAY,
};

export const ORDERS = [
  {
    name: 'Volume',
    fullName: 'Trade Volume',
    sort: 'traded',
  },
  {
    name: 'Price',
    fullName: 'Price Change',
    sort: 'movers',
  },
  {
    name: 'New Arrivals',
    fullName: 'New Arrivals',
    sort: 'newest',
  },
  {
    name: 'Expiring',
    fullName: 'Expiring',
    sort: 'closing',
  },
  {
    name: 'Investment',
    fullName: 'Investment',
    sort: 'investment',
  },
  {
    name: 'Gain',
    fullName: 'Gain',
    sort: 'gain',
  },
  {
    name: 'Loss',
    fullName: 'Loss',
    sort: 'loss',
  },
];

export const ORDERS_WITH_TIMESPAN_FILTER = ['movers', 'traded'];

export const TIMESPANS = [
  AVAILABLE_TIMESPANS.TODAY,
  AVAILABLE_TIMESPANS['3DAY'],
  AVAILABLE_TIMESPANS.WEEK,
  AVAILABLE_TIMESPANS.MONTH,
  AVAILABLE_TIMESPANS.ALL,
];

const DATE_FORMAT = 'YYYY-MM-DD';

// Turns a relative timespan keyword into an absolute calendar-date range, so
// URLs carrying it stay reproducible (Google Search Central: avoid relative
// URL params like ?date=yesterday). ALL/EMPTY are already absolute - no range.
// `now` is passed in by the caller so a range is only ever resolved once, not
// recomputed on every read.
export const resolveTimespanDateRange = (parameter, now) => {
  const dateTo = moment(now).format(DATE_FORMAT);
  switch (parameter) {
    case 'TODAY':
      return { dateFrom: dateTo, dateTo };
    case '3DAY':
      return { dateFrom: moment(now).subtract(3, 'days').format(DATE_FORMAT), dateTo };
    case 'WEEK':
      return { dateFrom: moment(now).subtract(7, 'days').format(DATE_FORMAT), dateTo };
    case 'MONTH':
      return { dateFrom: moment(now).subtract(1, 'month').format(DATE_FORMAT), dateTo };
    default:
      return { dateFrom: null, dateTo: null };
  }
};

// AVAILABLE_TIMESPANS/TIMESPANS constants in place, since other store modules
// (dashboard, watchlist) hold their own references to the same objects.
export const withDateRange = (timespan, now, overrides) => {
  if (!timespan) return timespan;
  const range = (overrides && overrides.dateFrom && overrides.dateTo)
    ? { dateFrom: overrides.dateFrom, dateTo: overrides.dateTo }
    : resolveTimespanDateRange(timespan.parameter, now);
  return { ...timespan, ...range };
};

export const selectTimespan = (state, parameter) => {
  state.selectedTimespan = withDateRange(find(state.timespans, { parameter }), new Date());
};

export const selectOrder = (state, sort) => {
  state.selectedOrder = find(state.orders, { sort });
  const timespan = DEFAULT_TIMESPANS_MARKETS[sort] || AVAILABLE_TIMESPANS.EMPTY;
  state.selectedTimespan = withDateRange(timespan, new Date());
  state.shouldShowTimespanFilter = ORDERS_WITH_TIMESPAN_FILTER
    .indexOf(state.selectedOrder.sort) !== -1;
};



// WEBPACK FOOTER //
// ./src/store/modules/filters_consts.js